export default __webpack_public_path__ + "static/media/msg.6d4c0804.svg";